import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import HeroBannerImage from '../assets/images/5800_2_07.jpg';

const HeroBanner = () => (
  <Box sx={{ mt: { lg: '212px', xs: '70px' }, ml: { sm: '50px' } }} position="relative" p="20px">
    <Typography color="darkblue" fontWeight="600" fontSize="26px">
      GymBud💪🏻
    </Typography>
    <Typography fontFamily="Alegreya" fontWeight={700} sx={{ fontSize: { lg: '44px', xs: '40px' } }} mb="23px" mt="30px">
      Sweat, Grind <br />
      And Rise
    </Typography>
    <Typography fontSize="22px" fontFamily="Alegreya" lineHeight="35px">
      You can view all the exercises you need
    </Typography>
    <Stack>
      <a
        href="#exercises"
        style={{
          marginTop: '45px',
          textDecoration: 'none',
          width: '200px',
          textAlign: 'center',
          background: 'blue',
          padding: '14px',
          fontSize: '22px',
          textTransform: 'none',
          color: 'white',
          borderRadius: '4px',
        }} // Added trailing comma here
      >
        Go To Exercises
      </a>
    </Stack>
    <Typography fontWeight={600} color="blue" sx={{ opacity: '0.1', display: { lg: 'block', xs: 'none' }, fontSize: '150px' }}>
      Let&apos;s Go
    </Typography>
    <img src={HeroBannerImage} alt="hero-banner" className="hero-banner-img" />
  </Box>
);

export default HeroBanner;

